import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
    downloadIcon: {
        marginTop: '-6px',
        display: 'inline-block',
    }
}));

export default useStyles;
